import { forwardRef } from 'react';
import type { TextControlBaseInstance } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { ShortText } from '../short-text';

export const Email = forwardRef<TextControlBaseInstance>(
  (forwardingProps, forwardingRef) => {
    return (
      <ShortText
        {...forwardingProps}
        className={createReadableClass({
          component: 'fields',
          element: 'email'
        })}
        ref={forwardingRef}
        type="email"
      />
    );
  }
);
